import { render, staticRenderFns } from "./watchkeeper.vue?vue&type=template&id=83033a7e&"
import script from "./watchkeeper.vue?vue&type=script&lang=js&"
export * from "./watchkeeper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports